import { render, staticRenderFns } from "./index3.5.vue?vue&type=template&id=35bff860&scoped=true"
import script from "./index3.5.vue?vue&type=script&lang=js"
export * from "./index3.5.vue?vue&type=script&lang=js"
import style0 from "./index3.5.vue?vue&type=style&index=0&id=35bff860&prod&lang=css"
import style1 from "./index3.5.vue?vue&type=style&index=1&id=35bff860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bff860",
  null
  
)

export default component.exports